import _ from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import classNames from 'classnames';
// @ts-ignore
import { Fluid, FluidItem } from '@tencent/spaui-fluid';
import { Button } from '@tencent/spaui';
import { BreadCrumb, FileUploader } from '@tencent/ptp-fe-common';
import Util from 'utils/index';
import api from 'pages/manage/application/api';
import { getIsvAppDetail } from 'pages/manage/application/services';
import { getCustomExtraKeyList, getLabelFromOptions } from 'pages/manage/application/util';
import ApplicationEdit from 'pages/manage/application/pages/edit';
import { NOT_UPDATE_APP_TIPS, TRANS_UPLOAD_NAME_LIST } from 'pages/manage/application/constants';
import { useAppDispatch, useTypedSelector } from 'store/index';
// import { fetchAppTypeOptions, getCsIndustryTree } from 'store/manager';
import { fetchAgencyDetail } from 'store/agency';
import { AgencyStatus } from 'model/agency';
import PreviewIcon from 'images/attachment-preview.png';
import { report } from 'store/report';
import '../index.scss';
// 每一项的header 标题
const FIELD_GROUP_MAP = {
  application: '应用详情',
};

const normalFieldNames: any = {
  FApplication_one: 1,
  FImage_app_icons: 1,
  FImage_screen_shot: 1,
  FApplication_link: 1,
  FApplication_link_app: 2,
  FApplication_two: 2,
};

interface FileDataProps {
  file_url?: string;
  public_file_url?: string;
  file_name?: string;
  name: string;
  url?: string;
  process?: number;
  id?: number | string;
  cos_file_name?: string;
  size?: number;
  lastModified?: string;
}
interface FieldProps {
  field_name?: any;
  field_zh_name?: any;
  highlight?: any;
  value?: any;
  text?: any;
  field_group?: any;
}

const bottomFieldNames: any[] = [];
const hiddenFieldNames: any[] = [];

const ApplicationDetail = () => {
  const history = useHistory();
  const { id: projectCode = '', name: projectName = '', type = '' } = useParams() as any;
  // console.log(projectCode, projectName, type);
  const isCreate = type === 'create';
  const {
    manager: { appTypeOptions, csIndustryTree, areaList },
    agency: { agencyDetail },
  } = useTypedSelector((state) => state);
  // 是否可以添加应用
  const notUpdateApp = ![AgencyStatus.pass, AgencyStatus.pause].includes(agencyDetail?.status);
  // 行业树
  const csIndustryData = Util.formatCsIndustryTree(
    {
      data: csIndustryTree,
      isFilterItem: true,
    },
    true
  );
  const csIndustryMap = Util.getCsIndustryMap(csIndustryTree, true); // 开户行业树id映射：根据'industry_short_id'建立
  // 区域树
  const areaTreeData = Util.formatAreaTree(areaList, true);

  const dispatch = useAppDispatch();
  const [projectInfo, setProjectInfo] = useState([]);
  const [detailInfo, setDetailInfo] = useState({}) as any;
  const [isEditing, setIsEditing] = useState(false);
  const [appIconsList, setAppIconsList] = useState([]);
  const [appScreenshotList, setAppScreenshotList] = useState([]);
  const [extraInfo, setExtraInfo] = useState([]);

  // 获取应用管理详情
  const loadProjectInfo = useCallback(async (projectCode: string) => {
    const projectInfo = await getIsvAppDetail(projectCode);
    const list = _.values(projectInfo);
    const { value: iconsList = [] } = _.find(list, ['field_name', 'FImage_app_icons']);
    const { value: shotList = [] } = _.find(list, ['field_name', 'FImage_screen_shot']);
    const { value: extra = [] } = _.find(list, ['field_name', 'extra']);
    setExtraInfo(_.map(extra, ({ label, value }: any) => ({ field_zh_name: label, text: value || '' })));
    setAppIconsList(iconsList);
    setAppScreenshotList(shotList);
    setDetailInfo(projectInfo);
    setProjectInfo(list);
  }, []);

  const extra = {
    project_code: projectCode,
    project_name: projectName,
  };
  // 更新列表数据
  const getProjectInfo = useMemo(() => _.debounce(loadProjectInfo, 0), [loadProjectInfo]);

  //  预览附件
  const previewIsvFile = (merchantUrl: string, merchantFileName: string, extra: any) => {
    window.open(merchantUrl);
    extra.file_name = merchantFileName;
    extra.action = 'ISV_APPLICATION_DETAIL_PREVIEW';
    extra.target = 'ISV-应用管理-详情-附件预览';
    // eventReport.savePageEvents(extra);
  };

  // 下载附件
  const deleteIsvFile = (merchantFileId: string, merchantFileName: string, extra: any) => {
    // const downloadUrl = api.fileDownload + merchantFileId;
    // window.open(downloadUrl);
    extra.file_name = merchantFileName;
    extra.action = 'ISV_APPLICATION_DETAIL_ATTACHMENT_DELETE';
    extra.target = 'ISV-应用管理-详情-附件删除';
    // eventReport.savePageEvents(extra);
  };

  useEffect(() => {
    !isCreate && getProjectInfo(projectCode);
    // dispatch(fetchAppTypeOptions());
    // dispatch(getCsIndustryTree());
    dispatch(fetchAgencyDetail());
  }, [dispatch, getProjectInfo, isCreate, projectCode]);

  useEffect(() => {
    report({ event: 'application_manage', payload: '应用详情界面' });
  }, []);
  // 渲染附件视图，区分内外部文档
  const renderAttachment = (item: any) => {
    const { text, value, time } = item;
    const previewUrl = value;
    // const { path = '' } = Util.getFileInfoByUrl(text);
    const showOpt = false; // 是否可以预览和下载
    return (
      <ul className="attachment">
        <div key={item} className="item">
          {/* <img src={path} className="img" alt="" />*/}
          <a
            style={{ cursor: 'pointer', color: '#296bef' }}
            target="_blank"
            onClick={() => previewIsvFile(previewUrl, text, extra)}
          >
            {text}
          </a>
          {/* <span className="file-text" title={text} >*/}
          {/*  {text}*/}
          {/* </span>*/}
          {showOpt && (
            <>
              <img
                src={PreviewIcon}
                className="img-preview"
                alt=""
                onClick={() => previewIsvFile(previewUrl, text, extra)}
              />
              <img
                // src={DeleteIcon}
                className="img-delete"
                alt=""
                onClick={() => deleteIsvFile(value, text, extra)}
              />
              {time && <span className="file-time"> {time} </span>}
            </>
          )}
        </div>
      </ul>
    );
  };

  const renderLink = (value: string) => (
    <a className="text-active" href={value}>
      {value || '-'}
    </a>
  );

  const handleFormatResponse = (data: FileDataProps) => ({ url: data.public_file_url, origin_name: data.file_name });

  const renderMediaViewer = (value: any) => (
    <FileUploader
      type="media"
      // @ts-ignore
      url={api.fileUpload}
      accept="image/jpeg,image/jpg,image/png,.mp4"
      uploadNotice="仅支持上传JPG/PNG/MP4文件，图片不超过1MB, 视频不超过10MB"
      onlyRead
      multiple
      value={value}
      onFormatResponse={handleFormatResponse}
    />
  );

  const renderFieldValue = (field: FieldProps) => {
    const { field_zh_name: fieldZhName, field_name: fieldName, value } = field;
    let { text } = field;
    if (_.includes(TRANS_UPLOAD_NAME_LIST, fieldZhName)) {
      // 解析合作案例数据
      try {
        text = _.isEmpty(text) ? '' : JSON.parse(text);
      } catch {}
      const list = _.map(text, ({ name, url }: any) => ({ text: name, value: url }));
      return (
        <>
          {_.map(list, (item: { value: any; text: any }, key: React.Key) => {
            if (item?.value && item.text) {
              return (
                <span key={key} className="item-row">
                  {renderAttachment(item)}
                </span>
              );
            }
            return null;
          })}
        </>
      );
    }
    switch (fieldName) {
      case 'FImage_app_icons':
        return renderMediaViewer(appIconsList);
      case 'FImage_screen_shot':
        return renderMediaViewer(appScreenshotList);
      case 'FIndustry_id':
        return getLabelFromOptions(csIndustryData, value, false, false) || '-';
      case 'Fcategory':
        return getLabelFromOptions(appTypeOptions, value, false, false) || '-';
      case 'FApplication_link':
      case 'FApplication_link_app':
        return renderLink(value);
      default:
        return Util.HTMLDecode(text) || '--';
    }
  };

  // 构建以field_group为key，建立每个选项对应的视图
  const renderField = (field: FieldProps, type: string) => {
    const { field_name, field_zh_name: fieldZhName, highlight } = field;
    let colType;
    if (type === 'normal') {
      colType = normalFieldNames[field_name] || 2;
    } else if (type === 'extra') {
      colType = 1;
    } else {
      colType = bottomFieldNames[field_name] || 2;
    }
    return (
      <div key={fieldZhName} className={classNames('panel-item', `col-${colType}`)}>
        <span className={classNames('panel-item-name', { highlight })}>{fieldZhName}</span>
        <span className={classNames('panel-item-content', { highlight })}>{renderFieldValue(field)}</span>
      </div>
    );
  };

  const renderGroupedProjectInfo = (fieldGroup: any, key: React.Key) => {
    const fields = _.filter(
      projectInfo || [],
      (field: FieldProps) => !hiddenFieldNames[field.field_name] && field.field_group === fieldGroup
    );
    const normalFields = _.filter(fields, (field: FieldProps) => !bottomFieldNames[field.field_name]);
    const bottomFields = _.filter(fields, (field: FieldProps) => bottomFieldNames[field.field_name]);
    const pptFile = _.last(_.filter(bottomFields, (item: FieldProps) => item.field_name === 'Fppt_file_id')); // 招商方案
    // 招商方案置顶
    if (!_.isEmpty(pptFile)) {
      _.remove(bottomFields, pptFile);
      bottomFields.unshift(pptFile);
    }
    if (normalFields.length === 0 && bottomFields.length === 0) {
      return null;
    }
    const renderNormalFields = _.map(normalFields || [], (field: FieldProps) => renderField(field, 'normal'));
    const renderExtraFields = _.map(extraInfo || [], (field: FieldProps) => renderField(field, 'extra'));
    return (
      <FluidItem key={key} className="layout">
        <Fluid className="item">
          <FluidItem>
            <div className="item-header" style={{ marginBottom: 0 }}>
              <span className="header" />
            </div>
          </FluidItem>
          {<FluidItem>{renderNormalFields}</FluidItem>}
          {<FluidItem>{renderExtraFields}</FluidItem>}
        </Fluid>
      </FluidItem>
    );
  };

  // 详情视图
  const detailView = useMemo(
    () => (
      <Fluid className="detail">
        {_.keys(FIELD_GROUP_MAP).map((fieldGroup: FieldProps, key: string) =>
          renderGroupedProjectInfo(fieldGroup, key)
        )}
      </Fluid>
    ),
    [renderGroupedProjectInfo]
  );

  const extraKeyList = getCustomExtraKeyList(detailInfo?.category?.value);
  const preData = detailInfo?.extra?.value;
  const getFormData = useMemo(() => {
    const params = {
      client_id: detailInfo?.client_id?.text,
      app_name: detailInfo?.app_name?.text,
      app_icon: detailInfo?.app_icon?.value,
      category: detailInfo?.category?.value,
      app_token: detailInfo?.app_token?.text,
      version: detailInfo?.version?.text,
      app_desc: detailInfo?.app_desc?.text,
      website_url: detailInfo?.website_url?.value,
      provider: detailInfo?.provider?.text,
      app_image_list: _.filter(detailInfo?.app_image_list?.value, ({ url = '' }) => !_.isEmpty(url)),
      industry_id: detailInfo?.industry_id?.value,
      redirect_uri: detailInfo?.redirect_uri?.value,
    } as any;
    _.map(extraKeyList, ({ label, name }: any) => {
      const matchList = _.find(preData, ['label', label]) || {};
      if (!_.isEmpty(matchList)) {
        const { label = '' } = matchList;
        let { value } = matchList;
        if (_.includes(TRANS_UPLOAD_NAME_LIST, label)) {
          // 解析合作案例数据
          try {
            value = _.isEmpty(value) ? '' : JSON.parse(value);
          } catch {}
        }
        params[name] = value;
      }
    });
    return params;
    // eslint-disable-next-line
  }, [detailInfo]);

  // 编辑视图
  const editView = useMemo(
    () => (
      <ApplicationEdit
        payloads={{
          clientId: detailInfo?.client_id?.text,
          id: projectCode,
          formData: getFormData,
          isCreate,
          csIndustryMap,
          csIndustryData,
          areaTreeData,
        }}
        customFunctions={{
          setIsEditing,
        }}
      />
    ),
    // eslint-disable-next-line
    [areaTreeData, csIndustryData, csIndustryMap, getFormData, isCreate, projectCode]
  );
  // 返回上一层
  const handleBack = useCallback(() => {
    history.push('/manage/application');
  }, [history]);

  // 面包屑导航配置
  const breadCrumbConfig = useMemo(
    () => ({
      backHref: handleBack,
      data: [{ label: '应用管理', onClick: handleBack }],
      label: isCreate ? '添加应用' : '应用详情',
    }),
    [handleBack, isCreate]
  );

  return (
    <div>
      <BreadCrumb {...breadCrumbConfig} />
      <div className="page-form-group">
        <div className="form-group-header">
          <h4>{isCreate ? '添加应用' : '应用管理信息'}</h4>
          {!isEditing && !isCreate && (
            <Button
              displayType="link"
              onClick={() => setIsEditing(true)}
              disabled={notUpdateApp}
              tip={notUpdateApp && NOT_UPDATE_APP_TIPS}
            >
              编辑应用
            </Button>
          )}
        </div>
        <div className="form-group-content">{isEditing || isCreate ? editView : detailView}</div>
      </div>
    </div>
  );
};
export default ApplicationDetail;
